/* @flow */

import { compose } from 'ramda';
import * as React from 'react';

type Props = {
  className: string,
  field: Object,
  inputProps: Object,
  list: ?Array<string>,
  handleFocus: () => void,
  handleBlur: () => void,
};

const FormikDatalist = ({
  className,
  field,
  inputProps,
  list,
  handleFocus,
  handleBlur,
}: Props): React.Node => {
  const options = list || [];
  const listId = `${inputProps.id}-options`;

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <React.Fragment>
      <input
        className={className}
        {...field}
        {...inputProps}
        type="text"
        list={listId}
        onFocus={handleFocus}
        onBlur={(e) => {
          field.onBlur(e);

          handleBlur();
        }}
      />
      <datalist id={listId}>
        {options.map((value) => (
          <option value={value} key={value}>
            {value}
          </option>
        ))}
      </datalist>
    </React.Fragment>
  );
};

export default compose(React.memo)(FormikDatalist);
